"use client";

import React, { useEffect, useRef, useState } from "react";

//Types
import { DropdownComponentProps } from "@/types";

//Styles
import * as S from "./styles";

//Icon
import icons from "@/assets/svg";

function isIconName(icon: any): icon is keyof typeof icons {
  return typeof icon === "string" && icon in icons;
}

const DropdwonComponent: React.FC<DropdownComponentProps> = ({
  titleButton,
  titleDropdown,
  items,
  children,
  variant,
  icon,
}) => {
  const allowedVariants = ["default", "danger", "warning", "success"] as const;
  const safeVariant: "default" | "danger" | "warning" | "success" | undefined =
    allowedVariants.includes(variant as any)
      ? (variant as "default" | "danger" | "warning" | "success")
      : undefined;

  const [open, setOpen] = useState<boolean>(false);
  const boxRef = useRef<HTMLDivElement | null>(null);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (boxRef.current && !boxRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close on ESC
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <S.DropdownBox ref={boxRef}>
      <S.DropdownButton
        $variant={safeVariant}
        onClick={() => setOpen((v) => !v)}
      >
        {isIconName(icon) ? <S.IconComponent name={icon} /> : icon}
        {titleButton}
      </S.DropdownButton>
      <S.Dropdown $open={open}>
        {children ? (
          <>
            {titleDropdown && (
              <S.DropdownTitle>{titleDropdown}</S.DropdownTitle>
            )}
            <S.DropdownContent>{children}</S.DropdownContent>
          </>
        ) : (
          <>
            {titleDropdown && (
              <S.DropdownTitle>{titleDropdown}</S.DropdownTitle>
            )}
            <S.DropdownContent>
              {items &&
                items
                  .filter((item) => !item.disabled)
                  .map((item, idx) => (
                    <S.DropdownItem
                      key={idx}
                      onClick={() => {
                        item.function?.();
                        setOpen(false);
                      }}
                    >
                      {item.link ? (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          {item.icon}
                          {item.label}
                        </a>
                      ) : (
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          {item.icon}
                          {item.label}
                        </span>
                      )}
                    </S.DropdownItem>
                  ))}
            </S.DropdownContent>
          </>
        )}
      </S.Dropdown>
    </S.DropdownBox>
  );
};

export default DropdwonComponent;
